import { Injectable } from '@angular/core';
import { MetaDefinition } from '@angular/platform-browser';

@Injectable()
export abstract class MetaTagsService {
  abstract addTag({ name, content }: MetaDefinition): void;

  abstract updateTag({ name, content, property }: MetaDefinition): void;

  abstract addTags(tagsArray: MetaDefinition[]): void;

  abstract setMetatags(tags): void;
}
